var WidgetHelp = window.WidgetHelp = (function () {
    var WidgetHelp = function (container) {
        this.dom = {
            container: null,
            slider: null,
            leftArrow: null,
            rightArrow: null,
        };

        this.dom.container = container;
        this.dom.slider = container.find('[js-node="widget-help-slider"]');
        this.dom.leftArrow = container.find(
            '[js-node="widget-help-arrow-left"]'
        );
        this.dom.rightArrow = container.find(
            '[js-node="widget-help-arrow-right"]'
        );

        this.isArrowClickBlocked = false;

        this.checkScrollPosition(this.dom.slider.scrollLeft());

        this.bindUI();
    };

    WidgetHelp.prototype.dispose = function () {
        this.unbindUI();
    };

    WidgetHelp.prototype.bindUI = function () {
        var self = this;

        self.dom.rightArrow.on('click', function () {
            if (!self.isArrowClickBlocked) {
                self.isArrowClickBlocked = true;
                self.slide({ direction: 'right' });
            }
        });

        self.dom.leftArrow.on('click', function () {
            if (!self.isArrowClickBlocked) {
                self.isArrowClickBlocked = true;
                self.slide({ direction: 'left' });
            }
        });

        var windowResizeTimer;
        $(window).on('resize', function () {
            clearTimeout(windowResizeTimer);
            windowResizeTimer = setTimeout(function () {
                self.checkScrollPosition(self.dom.slider.scrollLeft());
            }, 100);
        });
    };

    WidgetHelp.prototype.unbindUI = function () {
        app.console.log('unbind WidgetHelp');
    };

    WidgetHelp.prototype.slide = function (settings) {
        var self = this;
        var scrollPosition = self.dom.slider.scrollLeft();
        var newScrollPosition = 0;
        var scrollableAreaWidth = 340;

        settings.direction = settings.direction || '';

        if (settings.direction === 'right') {
            newScrollPosition = scrollPosition + scrollableAreaWidth;
        } else if (settings.direction === 'left') {
            newScrollPosition = scrollPosition - scrollableAreaWidth;
        }

        self.checkScrollPosition(newScrollPosition);

        self.dom.slider.animate(
            {
                scrollLeft: newScrollPosition,
            },
            600,
            function () {
                self.isArrowClickBlocked = false;
            }
        );
    };

    WidgetHelp.prototype.checkScrollPosition = function (scrollPosition) {
        var self = this;
        var scrollableAreaWidth =
            self.dom.slider[0].scrollWidth - self.dom.slider.width();

        self.dom.container.removeClass('m-without-right-arrow');
        self.dom.container.removeClass('m-without-left-arrow');

        if (scrollPosition <= 0) {
            self.dom.container.addClass('m-without-left-arrow');
        }

        if (scrollPosition >= scrollableAreaWidth) {
            self.dom.container.addClass('m-without-right-arrow');
        }
    };

    WidgetHelp.prototype.slideRight = function () {
        var self = this;
        var scrollLeft = self.dom.slider.scrollLeft();
        var newScrollLeft = scrollLeft + 190;

        if (
            newScrollLeft >=
            self.dom.slider[0].scrollWidth - self.dom.slider.width()
        ) {
            self.dom.container.addClass('m-without-right-arrow');
        }

        self.dom.slider.scrollLeft(newScrollLeft);
    };

    return WidgetHelp;
})();

var WidgetsHelp = (function () {
    var data = {
        widgets: [],
    };

    return {
        data: data,
        init: function () {
            $('[js-node="widget-help"]').each(function () {
                var container = $(this);
                data.widgets.push(new WidgetHelp(container));
            });
        },
        dispose: function () {},
    };
})();

$(function () {
    WidgetsHelp.init();
});
